module.exports = __webpack_public_path__ + "static/media/Trial1-if-correct.70859a35.mp3";